/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsLogos } from './FxIdDomainSettingsPublicWebClientConfigOptionsLogos';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLogos,
    FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsLogosToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsLogos';

/**
 * @type FxIdDomainSettingsCompanyBrandingConfigLogos
 * Логотипы
 * @export
 */
export type FxIdDomainSettingsCompanyBrandingConfigLogos = FxIdDomainSettingsPublicWebClientConfigOptionsLogos;

export function FxIdDomainSettingsCompanyBrandingConfigLogosFromJSON(json: any): FxIdDomainSettingsCompanyBrandingConfigLogos {
    return FxIdDomainSettingsCompanyBrandingConfigLogosFromJSONTyped(json, false);
}

export function FxIdDomainSettingsCompanyBrandingConfigLogosFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsCompanyBrandingConfigLogos {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLogos(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsCompanyBrandingConfigLogosToJSON(json: any): any {
    return FxIdDomainSettingsCompanyBrandingConfigLogosToJSONTyped(json, false);
}

export function FxIdDomainSettingsCompanyBrandingConfigLogosToJSONTyped(value?: FxIdDomainSettingsCompanyBrandingConfigLogos | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLogos(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLogosToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsLogos);
    }

    return {};
}

